exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-input-textarea .form-label {\n  margin-bottom: .5rem;\n}\n.form-input-textarea textarea {\n  display: block;\n  border-width: 1px;\n  padding: 1rem;\n}\n.form-input-textarea .has-error textarea,\n.form-input-textarea.has-error textarea {\n  border-color: #fecaca;\n}\n.form-input-textarea .has-error textarea:focus,\n.form-input-textarea.has-error textarea:focus {\n  border-color: #f87171;\n}\n", ""]);

// exports
